<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                        <div>
                            <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                        </div>
                        <div>Cette interface vous permet de prévisualiser les podiums de {{
                            mainStore.module.nom }} en fonction des catégories représentées par course.</div>
                        <PodiumsPreviewFilter @filter-change="onFilterChange" />
                        <div v-if="podiums_template" class="d-flex justify-end">
                            <SportipsButton @click="exportPodiumsTemplate" color="primary-dark" variant="outlined"
                                chevron arrowRight icon="mdi-file-pdf">
                                Exporter en PDF</SportipsButton>
                        </div>
                        <v-row v-if="podiums_template">
                            <v-col cols="12" md="6">
                                <div v-for="podium_template_category in male_podiums_with_inscrits"
                                    :key="podium_template_category.id" class="mb-4 spo-card pa-2 rounded bordered">
                                    <div class="text-h6 font-weight-bold">{{ podium_template_category.categorie ==
                                        'scratch' ?
                                        'Scratch'
                                        : 'Catégorie ' + podium_template_category.categorie }} Homme</div>
                                    <EmptyTablePodium :nb_rows="podium_template_category.nb_inscrits" />
                                </div>
                                <div>Les catégories homme non representées:</div>
                                <div>{{ male_podiums_without_inscrits }}</div>
                            </v-col>
                            <v-col cols="12" md="6">
                                <div v-for="podium_template_category in female_podiums_with_inscrits"
                                    :key="podium_template_category.id" class="mb-4 spo-card pa-2 rounded bordered">
                                    <div class="text-h6 font-weight-bold">{{ podium_template_category.categorie ==
                                        'scratch' ?
                                        'Scratch'
                                        : 'Catégorie ' + podium_template_category.categorie }} Femme</div>
                                    <EmptyTablePodium :nb_rows="podium_template_category.nb_inscrits" />
                                </div>
                                <div>Les catégories femme non representées:</div>
                                <div>{{ female_podiums_without_inscrits }}</div>
                            </v-col>

                        </v-row>
                    </div>
                </v-col>
            </v-row>

        </v-container>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PodiumsPreviewFilter from "@/components/Administration/Podiums_Preview/PodiumsPreviewFilter.vue";
import AdminService from "@/services/admin.service";
import EmptyTablePodium from "@/components/Administration/Podiums_Preview/EmptyTablePodium.vue";
export default {
    components: {
        PodiumsPreviewFilter,
        EmptyTablePodium,
    },
    computed: {
        ...mapStores(useMainStore),
        male_podiums_with_inscrits() {
            return this.podiums_template.Homme.filter(podium => podium.nb_inscrits > 0);
        },
        female_podiums_with_inscrits() {
            return this.podiums_template.Femme.filter(podium => podium.nb_inscrits > 0);
        },
        female_podiums_without_inscrits() {
            const podiums = this.podiums_template.Femme.filter(podium => podium.nb_inscrits == 0);
            return podiums.map(podium => podium.categorie).join(', ');
        },
        male_podiums_without_inscrits() {
            const podiums = this.podiums_template.Homme.filter(podium => podium.nb_inscrits == 0);
            return podiums.map(podium => podium.categorie).join(', ');
        },
    },
    data() {
        return {
            podiums_template: null,
            filters: {
                id_course: null,
                nb_recompenses_scratch: 3,
                nb_recompenses_categorie: 3,
            },
        };
    },
    methods: {
        async exportPodiumsTemplate() {
            const courseName = this.mainStore.module.courses.list.find(course => course.id == this.filters.id_course)?.nom;
            const moduleName = this.mainStore.module.nom;
            let params = {
                course: courseName,
                module: moduleName,
                male_podiums_with_inscrits: this.male_podiums_with_inscrits,
                female_podiums_with_inscrits: this.female_podiums_with_inscrits,
                male_podiums_without_inscrits: this.male_podiums_without_inscrits,
                female_podiums_without_inscrits: this.female_podiums_without_inscrits,
            }
            let blob = await AdminService.exportPodiumsTemplate(params);
            if (blob) {
                // Créer une URL pour le blob
                const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                // Créer un lien temporaire et déclencher le téléchargement
                const link = document.createElement('a');
                link.href = url;
                const fileName = `podiums_${moduleName}_${courseName || 'all'}_${new Date().toISOString().split('T')[0]}.pdf`;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                // Nettoyer
                link.remove();
                window.URL.revokeObjectURL(url);
            }
        },
        async onFilterChange(filters) {
            // Gérer les changements de filtres ici
            this.filters = filters;
            let request = await AdminService.getPodiumsTemplate(filters);
            if (request) {
                this.podiums_template = request;
            }
        },
    },
}
</script>

<style lang="scss" scoped></style>